import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { StyleGuideDestroyInput, StyleGuideDestroyPayload } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TVariables = StyleGuideDestroyInput;
type TData = StyleGuideDestroyPayload;

export const useStyleGuideDestroy = (
  options: Omit<UseMutationOptions<TData, TGenericError, TVariables, unknown>, 'mutationFn'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    mutation styleGuideDestroy($input: StyleGuideDestroyInput!) {
      styleGuideDestroy(input: $input) {
        success
      }
    }
  `;

  return useMutation<TData, TGenericError, TVariables, unknown>({
    mutationFn: (input: TVariables): Promise<TData> =>
      client.request({
        data: {
          gql: graphql,
          variables: { input }
        }
      }),
    ...options
  });
};
